import { Typographies } from '@/theme';
import {
  Box,
  Button,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  styled,
} from '@mui/material';

interface ITableContainerStyledProps {
  attrs?: {
    withMinWidth?: boolean;
  };
}
export const TableContainerStyled = styled(Box)<ITableContainerStyledProps>(
  ({ theme, attrs: { withMinWidth } = {} }) => ({
    boxShadow: 'none',
    borderRadius: theme.spacing(1),
    overflowY: 'auto',
    backgroundColor: theme.palette.white.main,
    maxHeight: '100%',
    ...(withMinWidth && {
      minWidth: theme.typography.pxToRem(900),
    }),
  }),
);

export const Wrapper = styled(Box)(() => ({
  overflow: 'auto',
  width: '100%',
}));

export const TableStyled = styled(Table)(({ theme }) => ({
  overflow: 'auto',
  paddingInline: theme.spacing(2),
}));

export const TableHeadStyled = styled(TableHead)(({ theme }) => ({
  height: theme.typography.pxToRem(48),
}));
export const BoxTableStyled = styled(Box)(({ theme }) => ({
  gridColumn: '1/4',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));
export const TypographyHeader = styled(Typography)(({ theme }) => ({
  fontSize: Typographies.FONT_SIZE_CAPTION_2,
  color: theme.palette.dark.dark_4,
  fontWeight: Typographies.FONT_WEIGHT_BODY,
}));
export const TableCellStyled = styled(TableCell)(() => ({
  border: 0,
}));
export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
  textAlign: 'left',
}));
export const Row = styled(TableRow)(({ theme }) => ({
  height: theme.typography.pxToRem(56),
  fontSize: theme.typography.caption.fontSize,
  margin: theme.spacing(2),
  fontWeight: 400,
  color: theme.palette.white.main,
}));
export const TableCellEmpty = styled(TableCellStyled)(() => ({
  textAlign: 'center',
}));
export const AddButton = styled(Button)(({ theme }) => ({
  width: theme.typography.pxToRem(130),
}));
export const GridFooter = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
